import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const noResultStyle = {
	display: 'inline-block',
}

const NoResults = props => {
	const extra = props.searchTerm.length > 20 ? '¯\\_(ツ)_/¯ ' : ''
	return (
		<div className="search-result-section" style={noResultStyle}>
			<h3>Sorry {extra}</h3>
			<p style={{ width: '350px' }}>No Results Found for "{props.searchTerm}"</p>
			<ul className="list-unstyled" style={{ textAlign: 'left' }}>
				<li>
					<Link to="/" onClick={e => props.onClick(e)}>
						Home
					</Link>
				</li>
				<li>
					<Link to="/getting-started" onClick={e => props.onClick(e)}>
						Getting Started
					</Link>
				</li>
				<li>
					<Link to="/api" onClick={e => props.onClick(e)}>
						API Reference
					</Link>
				</li>
			</ul>
		</div>
	)
}

NoResults.propTypes = {
	searchTerm: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
}

export default NoResults



// WEBPACK FOOTER //
// ./src/components/search/NoResults.js